// extracted by mini-css-extract-plugin
export default {"card-container":"VideoPlaceholder_card-container__l1o12"};